import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import KeystrokeInputableText, {
  KeystrokeInputableTextId,
} from '@/components/keystrokeInputableText/KeystrokeInputableText.vue';
import PlbscfReadonlyValue from '@/components/plbscfReadonlyValue/PlbscfReadonlyValue.vue';

import { InputableTextMixin } from '@/components/inputableText/InputableText';
import 計画三表TableMixin from '@/entries/user/mixins/計画三表TableMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import AbstractPlbscfService, { PlbscfYearValue, YearItemType } from '@/classes/service/AbstractPlbscfService';
import { PlbscfListItemConfig } from '@/master/Plbscf';

type Keystroke = {
  id: KeystrokeInputableTextId;
  map: KeystrokeInputableTextId[][];
};

export default mixins(InputableTextMixin, 計画書Mixin, 計画三表TableMixin).extend({
  name: 'YearValueCell',

  components: {
    KeystrokeInputableText,
    PlbscfReadonlyValue,
  },

  props: {
    yearValue: {
      type: Object as PropType<PlbscfYearValue>,
      required: true,
    },
    config: {
      type: Object as PropType<PlbscfListItemConfig>,
      required: true,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    keystroke: {
      type: Object as PropType<Keystroke>,
      required: true,
    },
    isYConfig: {
      type: Boolean,
      default: false,
    },
    isCF計算書: {
      type: Boolean,
      default: false,
    },
  },

  data(): {
    yearItemType: typeof YearItemType;
  } {
    return {
      yearItemType: YearItemType,
    };
  },

  methods: {
    isNoValue(): boolean {
      return AbstractPlbscfService.isNoValue(this.config, this.yearValue);
    },
    isEditable(): boolean {
      return !this.isReadonly && AbstractPlbscfService.isEditable(this.config, this.yearValue);
    },
    getYearValue(): number {
      return AbstractPlbscfService.getYearValue(this.yearValue, this.isYConfig, this.isCF計算書);
    },
  },
});
